import React from 'react';

export default class Contact extends React.Component{
  render(){
    return ( 
      <p>Contact 2</p>
    )
  }
}